var gm_container = document.getElementById('cart__gift-note');

openToastEvent = new CustomEvent('openToast'); // custom event



function getGiftNote(){

    var textarea = gm_container.querySelector("textarea");
    var hasGiftNote = CartJS.getNote();

    if(hasGiftNote) {
        textarea.value = CartJS.getNote();
    }

}


function alertUser($type, $message){


  if($type === 'saved'){
    var messageContainer = document.getElementById('message-saved');
    var messageContainerMessage = messageContainer.getElementsByClassName('toast__p')[0];
    messageContainerMessage.innerText = $message;
    messageContainer.dispatchEvent(openToastEvent);

  }
  if($type === 'deleted'){
    var messageContainer = document.querySelector('#message-deleted');
    messageContainer.getElementsByClassName('toast__p')[0].innerText = $message;
    messageContainer.dispatchEvent(openToastEvent);
    
  }

  


}






function saveGiftNote(){
  var textarea = gm_container.querySelector("textarea");

  

  if( textarea.value.length > 0 ){

        CartJS.setNote(textarea.value, {
          "success": function() {
              
              alertUser('saved', textarea.value);
          },
          "error": function(errorThrown) {
              alert('Error: ' + errorThrown + '!');
          }
        });


  } else {
      alert('There is nothing to save. Please write a message in the provided box.');
  }
}


function destroyGiftNote(){
  var textarea = gm_container.querySelector("textarea");
  var message = "Your gift message has been removed.";
  var checkbox = gm_container.querySelector("input[type='checkbox']");
  if(textarea.value.length > 1){

    textarea.value = '';

    CartJS.setNote(null, {
      "success": function() {
        alertUser('deleted', message);
        checkbox.checked = false;
      },
      "error": function(errorThrown) {
          alert('Error: ' + errorThrown + '!');
      }
    });
  }
}

function editedGiftNote(){
  /// Gift note has been edited. 
  var saveBtn = gm_container.querySelector('#gift-message__save');
  gm_container.querySelector("textarea").addEventListener("input", (event) => {

      saveBtn.textContent = 'Save Changes';

  });
}


window.addEventListener('DOMContentLoaded', (event) => {

var gm_container = document.getElementById('cart__gift-note');

  if(gm_container){
      
      var saveBtn = gm_container.querySelector('#gift-message__save');
      var removeBtn = gm_container.querySelector('#gift-message__remove');


      if(CartJS.getNote()){

        var checkbox = gm_container.querySelector("input[type='checkbox']");
        checkbox.checked = true;
        getGiftNote();
        editedGiftNote();
     
      } 

      saveBtn.addEventListener("click", saveGiftNote);
      removeBtn.addEventListener("click",destroyGiftNote);

  }

});